/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ButtonosindexRouteImport } from './routes/buttonosindex'
import { Route as VolunteerRouteImport } from './routes/volunteer'
import { Route as TicketsRouteImport } from './routes/tickets'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PressRouteImport } from './routes/press'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as MapRouteImport } from './routes/map'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CampsRouteImport } from './routes/camps'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProgramIndexRouteImport } from './routes/program/index'
import { Route as CampsIndexRouteImport } from './routes/camps/index'
import { Route as ArtistsIndexRouteImport } from './routes/artists/index'
import { Route as AboutIndexRouteImport } from './routes/about/index'
import { Route as ProgramKidsRouteImport } from './routes/program/kids'
import { Route as ProgramDaytimeRouteImport } from './routes/program/daytime'
import { Route as CampsCampSlugRouteImport } from './routes/camps/$campSlug'
import { Route as ArtistsSlugRouteImport } from './routes/artists/$slug'
import { Route as AboutRulesRouteImport } from './routes/about/rules'
import { Route as AboutFaqRouteImport } from './routes/about/faq'

const ButtonosindexRoute = ButtonosindexRouteImport.update({
  id: '/buttonosindex',
  path: '/buttonosindex',
  getParentRoute: () => rootRouteImport,
} as any)
const VolunteerRoute = VolunteerRouteImport.update({
  id: '/volunteer',
  path: '/volunteer',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsRoute = TicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PressRoute = PressRouteImport.update({
  id: '/press',
  path: '/press',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersRoute = PartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => rootRouteImport,
} as any)
const MapRoute = MapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryRoute = GalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const CampsRoute = CampsRouteImport.update({
  id: '/camps',
  path: '/camps',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramIndexRoute = ProgramIndexRouteImport.update({
  id: '/program/',
  path: '/program/',
  getParentRoute: () => rootRouteImport,
} as any)
const CampsIndexRoute = CampsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CampsRoute,
} as any)
const ArtistsIndexRoute = ArtistsIndexRouteImport.update({
  id: '/artists/',
  path: '/artists/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutIndexRoute = AboutIndexRouteImport.update({
  id: '/about/',
  path: '/about/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramKidsRoute = ProgramKidsRouteImport.update({
  id: '/program/kids',
  path: '/program/kids',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramDaytimeRoute = ProgramDaytimeRouteImport.update({
  id: '/program/daytime',
  path: '/program/daytime',
  getParentRoute: () => rootRouteImport,
} as any)
const CampsCampSlugRoute = CampsCampSlugRouteImport.update({
  id: '/$campSlug',
  path: '/$campSlug',
  getParentRoute: () => CampsRoute,
} as any)
const ArtistsSlugRoute = ArtistsSlugRouteImport.update({
  id: '/artists/$slug',
  path: '/artists/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRulesRoute = AboutRulesRouteImport.update({
  id: '/about/rules',
  path: '/about/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutFaqRoute = AboutFaqRouteImport.update({
  id: '/about/faq',
  path: '/about/faq',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/buttonosindex': typeof ButtonosindexRoute
  '/camps': typeof CampsRouteWithChildren
  '/contact': typeof ContactRoute
  '/gallery': typeof GalleryRoute
  '/map': typeof MapRoute
  '/partners': typeof PartnersRoute
  '/press': typeof PressRoute
  '/privacy': typeof PrivacyRoute
  '/tickets': typeof TicketsRoute
  '/volunteer': typeof VolunteerRoute
  '/about/faq': typeof AboutFaqRoute
  '/about/rules': typeof AboutRulesRoute
  '/artists/$slug': typeof ArtistsSlugRoute
  '/camps/$campSlug': typeof CampsCampSlugRoute
  '/program/daytime': typeof ProgramDaytimeRoute
  '/program/kids': typeof ProgramKidsRoute
  '/about': typeof AboutIndexRoute
  '/artists': typeof ArtistsIndexRoute
  '/camps/': typeof CampsIndexRoute
  '/program': typeof ProgramIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/buttonosindex': typeof ButtonosindexRoute
  '/contact': typeof ContactRoute
  '/gallery': typeof GalleryRoute
  '/map': typeof MapRoute
  '/partners': typeof PartnersRoute
  '/press': typeof PressRoute
  '/privacy': typeof PrivacyRoute
  '/tickets': typeof TicketsRoute
  '/volunteer': typeof VolunteerRoute
  '/about/faq': typeof AboutFaqRoute
  '/about/rules': typeof AboutRulesRoute
  '/artists/$slug': typeof ArtistsSlugRoute
  '/camps/$campSlug': typeof CampsCampSlugRoute
  '/program/daytime': typeof ProgramDaytimeRoute
  '/program/kids': typeof ProgramKidsRoute
  '/about': typeof AboutIndexRoute
  '/artists': typeof ArtistsIndexRoute
  '/camps': typeof CampsIndexRoute
  '/program': typeof ProgramIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/buttonosindex': typeof ButtonosindexRoute
  '/camps': typeof CampsRouteWithChildren
  '/contact': typeof ContactRoute
  '/gallery': typeof GalleryRoute
  '/map': typeof MapRoute
  '/partners': typeof PartnersRoute
  '/press': typeof PressRoute
  '/privacy': typeof PrivacyRoute
  '/tickets': typeof TicketsRoute
  '/volunteer': typeof VolunteerRoute
  '/about/faq': typeof AboutFaqRoute
  '/about/rules': typeof AboutRulesRoute
  '/artists/$slug': typeof ArtistsSlugRoute
  '/camps/$campSlug': typeof CampsCampSlugRoute
  '/program/daytime': typeof ProgramDaytimeRoute
  '/program/kids': typeof ProgramKidsRoute
  '/about/': typeof AboutIndexRoute
  '/artists/': typeof ArtistsIndexRoute
  '/camps/': typeof CampsIndexRoute
  '/program/': typeof ProgramIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/buttonosindex'
    | '/camps'
    | '/contact'
    | '/gallery'
    | '/map'
    | '/partners'
    | '/press'
    | '/privacy'
    | '/tickets'
    | '/volunteer'
    | '/about/faq'
    | '/about/rules'
    | '/artists/$slug'
    | '/camps/$campSlug'
    | '/program/daytime'
    | '/program/kids'
    | '/about'
    | '/artists'
    | '/camps/'
    | '/program'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/buttonosindex'
    | '/contact'
    | '/gallery'
    | '/map'
    | '/partners'
    | '/press'
    | '/privacy'
    | '/tickets'
    | '/volunteer'
    | '/about/faq'
    | '/about/rules'
    | '/artists/$slug'
    | '/camps/$campSlug'
    | '/program/daytime'
    | '/program/kids'
    | '/about'
    | '/artists'
    | '/camps'
    | '/program'
  id:
    | '__root__'
    | '/'
    | '/buttonosindex'
    | '/camps'
    | '/contact'
    | '/gallery'
    | '/map'
    | '/partners'
    | '/press'
    | '/privacy'
    | '/tickets'
    | '/volunteer'
    | '/about/faq'
    | '/about/rules'
    | '/artists/$slug'
    | '/camps/$campSlug'
    | '/program/daytime'
    | '/program/kids'
    | '/about/'
    | '/artists/'
    | '/camps/'
    | '/program/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ButtonosindexRoute: typeof ButtonosindexRoute
  CampsRoute: typeof CampsRouteWithChildren
  ContactRoute: typeof ContactRoute
  GalleryRoute: typeof GalleryRoute
  MapRoute: typeof MapRoute
  PartnersRoute: typeof PartnersRoute
  PressRoute: typeof PressRoute
  PrivacyRoute: typeof PrivacyRoute
  TicketsRoute: typeof TicketsRoute
  VolunteerRoute: typeof VolunteerRoute
  AboutFaqRoute: typeof AboutFaqRoute
  AboutRulesRoute: typeof AboutRulesRoute
  ArtistsSlugRoute: typeof ArtistsSlugRoute
  ProgramDaytimeRoute: typeof ProgramDaytimeRoute
  ProgramKidsRoute: typeof ProgramKidsRoute
  AboutIndexRoute: typeof AboutIndexRoute
  ArtistsIndexRoute: typeof ArtistsIndexRoute
  ProgramIndexRoute: typeof ProgramIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/buttonosindex': {
      id: '/buttonosindex'
      path: '/buttonosindex'
      fullPath: '/buttonosindex'
      preLoaderRoute: typeof ButtonosindexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/volunteer': {
      id: '/volunteer'
      path: '/volunteer'
      fullPath: '/volunteer'
      preLoaderRoute: typeof VolunteerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets': {
      id: '/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof TicketsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/press': {
      id: '/press'
      path: '/press'
      fullPath: '/press'
      preLoaderRoute: typeof PressRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners': {
      id: '/partners'
      path: '/partners'
      fullPath: '/partners'
      preLoaderRoute: typeof PartnersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/map': {
      id: '/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof MapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery': {
      id: '/gallery'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof GalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/camps': {
      id: '/camps'
      path: '/camps'
      fullPath: '/camps'
      preLoaderRoute: typeof CampsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/program/': {
      id: '/program/'
      path: '/program'
      fullPath: '/program'
      preLoaderRoute: typeof ProgramIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/camps/': {
      id: '/camps/'
      path: '/'
      fullPath: '/camps/'
      preLoaderRoute: typeof CampsIndexRouteImport
      parentRoute: typeof CampsRoute
    }
    '/artists/': {
      id: '/artists/'
      path: '/artists'
      fullPath: '/artists'
      preLoaderRoute: typeof ArtistsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about/': {
      id: '/about/'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/program/kids': {
      id: '/program/kids'
      path: '/program/kids'
      fullPath: '/program/kids'
      preLoaderRoute: typeof ProgramKidsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/program/daytime': {
      id: '/program/daytime'
      path: '/program/daytime'
      fullPath: '/program/daytime'
      preLoaderRoute: typeof ProgramDaytimeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/camps/$campSlug': {
      id: '/camps/$campSlug'
      path: '/$campSlug'
      fullPath: '/camps/$campSlug'
      preLoaderRoute: typeof CampsCampSlugRouteImport
      parentRoute: typeof CampsRoute
    }
    '/artists/$slug': {
      id: '/artists/$slug'
      path: '/artists/$slug'
      fullPath: '/artists/$slug'
      preLoaderRoute: typeof ArtistsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about/rules': {
      id: '/about/rules'
      path: '/about/rules'
      fullPath: '/about/rules'
      preLoaderRoute: typeof AboutRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about/faq': {
      id: '/about/faq'
      path: '/about/faq'
      fullPath: '/about/faq'
      preLoaderRoute: typeof AboutFaqRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface CampsRouteChildren {
  CampsCampSlugRoute: typeof CampsCampSlugRoute
  CampsIndexRoute: typeof CampsIndexRoute
}

const CampsRouteChildren: CampsRouteChildren = {
  CampsCampSlugRoute: CampsCampSlugRoute,
  CampsIndexRoute: CampsIndexRoute,
}

const CampsRouteWithChildren = CampsRoute._addFileChildren(CampsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ButtonosindexRoute: ButtonosindexRoute,
  CampsRoute: CampsRouteWithChildren,
  ContactRoute: ContactRoute,
  GalleryRoute: GalleryRoute,
  MapRoute: MapRoute,
  PartnersRoute: PartnersRoute,
  PressRoute: PressRoute,
  PrivacyRoute: PrivacyRoute,
  TicketsRoute: TicketsRoute,
  VolunteerRoute: VolunteerRoute,
  AboutFaqRoute: AboutFaqRoute,
  AboutRulesRoute: AboutRulesRoute,
  ArtistsSlugRoute: ArtistsSlugRoute,
  ProgramDaytimeRoute: ProgramDaytimeRoute,
  ProgramKidsRoute: ProgramKidsRoute,
  AboutIndexRoute: AboutIndexRoute,
  ArtistsIndexRoute: ArtistsIndexRoute,
  ProgramIndexRoute: ProgramIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
